
import { SVGProps } from 'react';
const SvgInfo12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M6 2.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM1.25 6a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0ZM6 5.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 6 5.25Zm0-2a.75.75 0 0 0 0 1.5h.004a.75.75 0 0 0 0-1.5H6Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgInfo12;
